module.exports = __webpack_public_path__ + "img/logo.e0e3e97b.png";